<template>
  <div
    class="bottom-bar"
    v-if="checkOnDevice()[0] || checkOnDevice()[2]"
  >
    <ul>
      <li>
        <router-link to="/roadbookEdit">
          <search
            :class="route.name === 'roadbook_edit' ? 'text-primary' : 'text-gray-400'"
            :size="30"
            :stroke-width="2.5"
          />
        </router-link>
      </li>
      <li>
        <router-link to="/roadbookSelectionMobile">
          <shopping-basket
            :class="route.name === 'roadbookSelectionMobile' ? 'text-primary' : 'text-gray-400'"
            :size="30"
            :stroke-width="2"
          />
          <span
            class="counter"
            v-if="leafletsSelection > 0"
            >{{ leafletsSelection }}</span
          >
        </router-link>
      </li>

      <li>
        <router-link to="/clientInfo">
          <!-- <router-link :to="{ name: 'clientInfo', query: { isInOverlay: 'true' } }"> -->
          <id-card
            :class="route.name === 'clientInfo' ? 'text-primary' : 'text-gray-400'"
            :size="30"
            :stroke-width="2"
          />
        </router-link>
      </li>
      <li>
        <router-link to="/roadbookPreview">
          <send
            :class="route.name === 'roadbookPreview' ? 'text-primary' : 'text-gray-400'"
            :size="25"
            :stroke-width="2.5"
          />
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { useMixin } from '@/utils/mixins/useMixin.mixin';
  import { IdCard, Search, Send, ShoppingBasket } from 'lucide-vue-next';
  import { useRoute } from 'vue-router';

  // General
  const { checkOnDevice } = useMixin();

  const route = useRoute();

  defineProps({
    leafletsSelection: {
      type: Number,
      default: 0,
    },
  });
</script>

<style lang="postcss">
  .bottom-bar {
    @apply fixed bottom-0 left-0 w-full bg-white border-t px-[30px] py-4;

    @media screen and (min-width: 1024px) {
      @apply hidden;
    }

    ul {
      @apply flex justify-center items-center gap-10;
    }

    a {
      @apply relative h-[50px] w-[50px] flex justify-center items-center rounded-full transition;

      &.router-link-active,
      &.router-link-exact-active {
        @apply bg-primary/20 pointer-events-none;
      }
    }

    .counter {
      @apply absolute top-[8px] right-[8px] h-[16px] w-[16px] flex justify-center items-center text-white bg-red-600 rounded-full text-[10px] font-medium;
    }
  }
</style>
